var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGloblePhysio({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3716",
    "data-name": "Group 3716",
    transform: "translate(-865 -340)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_323",
    "data-name": "Ellipse 323",
    cx: 42,
    cy: 42,
    r: 42,
    transform: "translate(865 340)",
    fill: "#fcf4f1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3715",
    "data-name": "Group 3715",
    transform: "translate(878.407 356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17208",
    "data-name": "Path 17208",
    d: "M19.863,73.057c.635,0,1.286,0,1.951,0H34.4c.664,0,1.315,0,1.95,0,5.823,0,10.272-.3,10.272-6.385A12.222,12.222,0,0,0,35.525,54.5c-.049,2.229-7.417,7.73-7.417,7.73s-7.369-5.5-7.419-7.73a12.222,12.222,0,0,0-11.1,12.17c0,6.087,4.448,6.385,10.27,6.385ZM33.6,64.744a.348.348,0,0,1,.367-.328h1.99V62.427a.349.349,0,0,1,.327-.367h1.964a.348.348,0,0,1,.327.367v1.99h1.989a.349.349,0,0,1,.367.328v1.963a.348.348,0,0,1-.367.328h-1.99v1.989a.349.349,0,0,1-.328.367H36.289a.348.348,0,0,1-.328-.367v-1.99H33.972a.349.349,0,0,1-.367-.328Z",
    transform: "translate(0 -26.82)",
    fill: "#f16238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17209",
    "data-name": "Path 17209",
    d: "M37.959,29.28c5.628,0,10.19-8.463,10.19-14.091a10.19,10.19,0,0,0-20.38,0C27.769,20.817,32.331,29.28,37.959,29.28Z",
    transform: "translate(-9.848 0)",
    fill: "#f6ad93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGloblePhysio);
export default __webpack_public_path__ + "static/media/Globle Physio.b9498b016ab77e58aa17c28b70f6a4b8.svg";
export { ForwardRef as ReactComponent };